<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <div class="mar-top">
      <van-cell-group class="large-z-index">
        <van-cell title="新建会议群组" icon="add-o" class="text-primary"
                  :clickable="true" @click="pushToSubPage()"></van-cell>
      </van-cell-group>
      <div class="mar-top">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div v-if="refreshTime && !groupData.length">
            <empty-notice :image="'search'" :desc="'暂无群组信息'"></empty-notice>
          </div>

          <div v-else class="custom-steps">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <van-cell-group title="我的会议群组">
                <van-swipe-cell v-for="doc in groupData" :key="doc.psgId">
                  <van-cell :title="doc.name + `（${doc.members.length}人）`"
                            :clickable="true" @click="pushToSubPage(doc.psgId)">
                    <template #label>
                      <span>{{formatMembers(doc.members)}}</span>
                    </template>
                  </van-cell>
                  <template #right>
                    <van-button square type="danger" class="hgt-100-percent"
                                @click="handleDelete(doc)">删除
                    </van-button>
                  </template>
                </van-swipe-cell>
              </van-cell-group>
            </van-list>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
  // import {getStorage, StorageKey} from "../../../../tools/storage";
  import {refreshDebounce, frontConfirm, checkRespCorrect} from "../../../../tools/utils";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import {personalGroup} from "../../../../server"
  import routerMeta from "../../router/routerMeta";

  export default {
    data() {
      return {
        refreshing: false,
        refreshTime: "",
        groupMap: {},
        finished: false,
        loading: false,
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
      }
    },
    computed: {
      // 通过对象key进行排序，保证分页数据顺序
      groupData() {
        // console.log(Object.keys(this.groupMap))
        return Object.values(this.groupMap).flat(1)
      },
    },
    mounted() {
    },
    methods: {
      onRefresh() {
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initGroupList()
      },
      initGroupList() {
        this.pageInfo.pageNum = 1;
        this.refreshTime = "";
        this.groupMap = {};
        this.finished = false;
        this.onLoad()
      },
      onLoad() {
        this.getGroupList(this.pageInfo.pageNum++)
      },
      getGroupList(pageNum) {
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
        };
        !this.refreshing && !this.loading && UILoader.load();
        personalGroup.queryList(this, {queryFilter: filter}).then(({searchPersonalGroup: data = {}}) => {
          UILoader.unload();
          // 列表懒加载
          this.loading = false;
          const {personalGroupEdges, pageInfo} = data;
          // console.log(personalGroupEdges);
          this.groupMap = {
            ...this.groupMap,
            [pageNum]: (personalGroupEdges || []).map(e => ({...e.personalGroup}))
          };
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        })
      },
      formatMembers(members = []) {
        return members.slice(0, 20).map(e => e.name).join('、') + (members.length > 25 ? "..." : "")
      },
      pushToSubPage(psgId) {
        if (psgId) {
          this.$router.push({name: routerMeta.editPersonalGroup.name, params: {psgId: psgId}})
        } else {
          this.$router.push({name: routerMeta.newPersonalGroup.name})
        }
      },
      handleDelete(doc) {
        // console.log(doc.psgId)
        frontConfirm({
          title: "删除确认",
          msg: `是否确认删除会议群组：${doc.name}（${doc.members.length}人）？`,
        }, () => {
          personalGroup.deletePersonalGroup(this, {psgId: doc.psgId}).then(({deletePersonalGroup: resp = {}}) => {
            if (checkRespCorrect(resp, "保存失败")) {
              messageHdl({code: msgCode.SUCCESS});
              this.initGroupList()
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        })
      },
    }
  }
</script>

<style scoped>
</style>
